import { init, initTrackPageview, PlatformName } from '@cbhq/client-analytics';

import { pageKeyRegex } from ':fat/analytics/pageKey';
import { reportError } from ':fat/init/bugsnag';
import {
  AMPLITUDE_API_KEY,
  ANALYTICS_DEBUG_LOGGING,
  isClient,
  isProductionRelease,
} from ':fat/init/env';
import { history } from ':fat/init/history';

export function initAmplitude() {
  if (isClient) {
    init({
      amplitudeApiKey: AMPLITUDE_API_KEY,
      isAlwaysAuthed: false,

      // Only send events to production datadog for Commerce prod, not dev/stage.
      isProd: isProductionRelease,

      // Error handling listener for custom error reporting
      onError: (error) => {
        reportError(error, { context: 'analytics_sdk', severity: 'warning' });
      },

      platform: PlatformName.web,
      projectName: 'commerce-funds-access-tool',
      showDebugLogging: !isProductionRelease && ANALYTICS_DEBUG_LOGGING === 'enabled',
    });
  }
}

// Initiate auto-instrumented page view events
export function initPageViewAnalytics() {
  return initTrackPageview({
    blacklistRegex: [],
    browserHistory: history,
    pageKeyRegex,
  });
}
